import { motion } from "framer-motion";

const quotes = [
    { q: "Colecle unified our procurement lifecycle end-to-end. We went from 12-week tenders to 4 weeks with full auditability.", n: "Ministry of Finance", r: "Director of Procurement" },
    { q: "The digital stamp registry replaced a paper-driven, forgery-prone process. Verification is now instantaneous.", n: "National Regulator", r: "Chief Compliance Officer" },
    { q: "One dashboard for our national infrastructure. Downtime dropped 74% in the first quarter after rolling out Monitor.", n: "Financial Services Group", r: "Head of ICT" },
];

export default function Testimonials() {
    return (
        <section data-testid="testimonials" className="bg-white">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-36">
                <div className="grid lg:grid-cols-12 gap-8 mb-16">
                    <div className="lg:col-span-6">
                        <div className="eyebrow">Case Studies</div>
                        <h2 className="headline text-4xl md:text-5xl lg:text-6xl mt-4 text-navy">
                            Trusted by institutions <br /> that don't play.
                        </h2>
                    </div>
                </div>
                <div className="grid lg:grid-cols-3 gap-6">
                    {quotes.map((q, i) => (
                        <motion.figure
                            key={i}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            className="bg-[#F7F9FC] border border-slate-200 rounded-2xl p-8"
                        >
                            <div className="font-serif text-4xl text-[#E8B923] leading-none">“</div>
                            <blockquote className="font-serif text-xl md:text-2xl text-navy leading-snug mt-3">
                                {q.q}
                            </blockquote>
                            <figcaption className="mt-6 pt-6 border-t border-slate-200">
                                <div className="text-navy text-sm font-medium">{q.n}</div>
                                <div className="text-slate-500 text-xs mt-1 font-mono">{q.r}</div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
